module.exports = __webpack_public_path__ + "static/img/TH@2x.30de7f8f.jpg";